var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-box-container",
      attrs: { id: _vm.phone.id },
      on: {
        mouseup: function($event) {
          _vm.$_can("phone-numbers.show") || _vm.$_can("phone-numbers.view-own")
        }
      }
    },
    [
      [
        _c("div", { staticClass: "d-flex list-box-header col-12 pointer" }, [
          _c(
            "div",
            { staticClass: "pl-0 list-box-header-left col-lg-7 col-7 pr-3" },
            [
              _c(
                "div",
                { staticClass: "pl-0 d-flex align-items-center col-7" },
                [
                  _c(
                    "div",
                    { staticClass: "list-box-status align-items-start col-12" },
                    [
                      _c("span", { staticClass: "ref-id" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.phoneMask.maskedPhone(_vm.phone.phone_number)
                            ) +
                            "\n            "
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-0 d-flex align-items-center col-5" },
                [
                  _c(
                    "div",
                    { staticClass: "list-box-status align-items-start col-12" },
                    [
                      _vm.phone.company
                        ? _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.phone.company.name) +
                                "\n            "
                            )
                          ])
                        : _vm.phone.carrier
                          ? _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.phone.carrier.name) +
                                  "\n            "
                              )
                            ])
                          : _c("span", [
                              _vm._v("\n              -\n            ")
                            ])
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-box-header-right col-lg-5 col-5 pl-4" },
            [
              _c("div", { staticClass: "d-flex align-items-center col-7" }, [
                _vm.phone.type
                  ? _c("div", { staticClass: "phone-phones" }, [
                      _vm.phone.type.id === 1
                        ? _c("span", { staticClass: "management" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.phone.type.name) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.phone.type.id === 2
                        ? _c("span", { staticClass: "claims-roles" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.phone.type.name) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _c("div", { staticClass: "phone-phones" }, [
                      _vm._v("\n            -\n          ")
                    ])
              ]),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn-secondary add-filter",
                attrs: { type: "button", id: "dropdownMenuButton" },
                on: {
                  click: function($event) {
                    _vm.$_can("phone-numbers.show") &&
                      _vm.$emit("openEditModal")
                  }
                }
              })
            ]
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0b4a5dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0b4a5dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SettingsPhoneNumbersBlock.vue
// module id = null
// module chunks = 